import { useLocale } from "../components/LocaleProvider";

const usePublicPath = () => {
	return "/bread";
};

const useLocalePublicPath = () => {
	const { locale } = useLocale();
	const publicPath = usePublicPath();
	return `${publicPath}/${locale}`;
};

export { useLocalePublicPath };
